// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1tt6I","title":"ClientInsurance_title__3FQWB","itemText":"ClientInsurance_itemText__2iS12"};